import { Modal } from 'components';
import React, { FC } from 'react';

type Props = {};

const InviteResellerPage: FC<Props> = (props) => {
  return (
    <Modal
      title={'Invite Reseller'}
      open={true}
      setOpen={function (val: boolean): void {
        throw new Error('Function not implemented.');
      }}
    >
      import
    </Modal>
  );
};

export default InviteResellerPage;
